import script from "./ShotAnimation.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShotAnimation.vue?vue&type=script&setup=true&lang=ts"

import "./ShotAnimation.vue?vue&type=style&index=0&id=5f1728c2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f1728c2"]])

export default __exports__